import { Link } from 'react-router-dom'
import type { FeaturedExpert } from '../../types'
import { ExpertCard } from '../common/ExpertCard'

interface FeaturedExpertsProps {
  experts: FeaturedExpert[]
}

export function FeaturedExperts({ experts }: FeaturedExpertsProps) {
  if (!experts || experts.length === 0) {
    return null
  }

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-3xl font-bold text-gray-900">Featured Experts</h2>
            <p className="mt-2 text-gray-600">Verified professionals ready to work</p>
          </div>
          <Link
            to="/experts"
            className="text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1"
          >
            Browse All Experts
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {experts.slice(0, 6).map((expert) => (
            <ExpertCard key={expert.id} expert={expert} />
          ))}
        </div>
      </div>
    </section>
  )
}
